import { styled } from '@mui/material/styles';

const StyledAgentName = styled('h3')`
  margin: 0;
  text-transform: capitalize;
`;

export default StyledAgentName;
